const admin = () =>
  import ('@/mob/views/admin/admin')
const claimStore = () =>
  import ('@/mob/views/claimStore')
const createStore = () =>
  import ('@/mob/views/createStore')


const adminRouter = {
  path: '/admin',
  component: admin
}


// 认领门店失败
const baseLimitRouter = [{ //新建门店
  path: '/create',
  component: createStore
}, { //修改门店
  path: '/create/:storeId',
  component: createStore
}]



export default [adminRouter, ...baseLimitRouter]



// WEBPACK FOOTER //
// ./src/router/mob/admin.js